import { store } from '@/store/index'
import { toArray } from './array'

// 役割スラグの型定義
export const ROLE_SLUGS = {
  real_trade_lab: ['real_trade_lab', 'trial_trade_lab_202409'] as const,
  shindo: 'shindo',
} as const

// すべての役割スラグをカバーするUnion型
type AllRoleSlugs = typeof ROLE_SLUGS[keyof typeof ROLE_SLUGS][number];

// isUserRole関数の修正
export const isUserRole = (roleSlugs: AllRoleSlugs[]) => {
  const roles = toArray(store.state.user.user?.roles)

  return roleSlugs.every(slug =>
    roles.some(role =>
      Array.isArray(ROLE_SLUGS[slug as keyof typeof ROLE_SLUGS])
        ? (ROLE_SLUGS[slug as keyof typeof ROLE_SLUGS] as readonly string[]).includes(role.slug)
        : role.slug === ROLE_SLUGS[slug as keyof typeof ROLE_SLUGS]
    )
  )
}
